import { render } from "./NotFound.vue?vue&type=template&id=eb5f031e&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=ts"
export * from "./NotFound.vue?vue&type=script&lang=ts"

import "./NotFound.vue?vue&type=style&index=0&id=eb5f031e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-eb5f031e"

export default script